// eslint-disable-next-line
const theme = {
  colors: {
    primary: "#0F2554",
    button_primary: "#0F2554",
    button_secundary: "#24CC63",
    error: "#ED1616",
    white: "#FFF",
    black: "#000",
    title_login: "#5E5873",
    text_login: "#6E6B7B",
    text_footer: "#9B9B9B",
    black: "#000",
  },
};
export default theme;
